<template>
  <v-timeline-item
    dot-color="systemActivity"
    icon="mdi-trash-can-outline"
    fill-dot
  >
    <v-expansion-panels
      class="expansion-panels"
      variant="accordion"
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-title>
          <v-row
            no-gutters
            align="center"
            class="d-flex justify-center"
            :class="{ 'flex-column': $vuetify.display.smAndDown }"
          >
            <v-col md="8">
              <div class="mb-2 text-subtitle-1">
                {{ $t('lead-timeline.crm-lead-deleted.title', { readableCrmName }) }}
              </div>
              <div class="text-grey">
                {{ $t('lead-timeline.crm-lead-deleted.subtitle', { readableCrmName }) }}
              </div>
            </v-col>
            <v-col
              class="pr-2 text-right text-grey"
              :class="{ 'text-start mt-2': $vuetify.display.smAndDown }"
              md="4"
            >
              {{ formatDate(data.createdAt) }}
            </v-col>
          </v-row>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-row>
            <v-col cols="12">
              <v-list density="compact">
                <v-list-item class="px-0">
                  <div>
                    <p>
                      {{
                        $t('lead-timeline.crm-lead-deleted.body-texts.0', {
                          readableCrmName,
                          readablePlatformName,
                        })
                      }}<br />
                      {{
                        $t('lead-timeline.crm-lead-deleted.body-texts.1', { readablePlatformName })
                      }}
                    </p>
                    <DeleteContact :lead="lead" />
                  </div>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-timeline-item>
</template>
<script>
import brandingMixin from '@/mixins/branding'
import crmMixin from '@/mixins/crm'

import DeleteContact from '../DeleteContact.vue'

export default {
  components: {
    DeleteContact,
  },
  mixins: [brandingMixin, crmMixin],
  props: {
    data: { type: Object, default: null },
    leadId: { type: String, default: null },
    leadCrmLink: { type: String, default: null },
    leadOrigin: { type: String, default: null },
  },
  computed: {
    lead() {
      return {
        leadId: this.leadId,
        crmLink: this.leadCrmLink,
        origin: this.leadOrigin,
      }
    },
  },
}
</script>

<style scoped>
.expansion-panels {
  margin: -24px -24px 0 -24px;
}
</style>
